export default __webpack_public_path__ + "static/media/237-tile.51574a95.svg";